<template>
  <div class="app-wrap df jcsb aic">
      
      <DashHeader :mode ="mode" v-if="(mode !== 'live2') && (mode !== 'login') && (mode !== 'terms') && (mode !== 'privacy') && (mode !== 'contact')" 
        :setSidebarShown="setSidebarShown"
        :sidebarShown="sidebarShown"
         class="header" />
      <LandingHeader v-if="showHeader1.indexOf(mode) > -1"
         class="header" />

      <div class="sidebar-bg"
        v-if="(mode !== 'login') && sidebarShown && (mode !== 'live2')"
        @click="setSidebarShown(false, 'a')"></div>
  
      <div class="app-bottom df jcsb aifs"
        v-bind:class="{
          'app-bottom-cupping': mode == 'live2',
          'no-top-margin': (mode == 'login') || (mode == 'contact') || (mode == 'privacy') || (mode == 'terms'),
        }">

        <Sidebar :sidebarShown="sidebarShown" 
        :setSidebarShown="setSidebarShown" 
        v-if="showSidebar.indexOf(mode) > -1"
        class="sidebar"/>

        <div class="app-side f1 df fdc jcsb aic" 
        v-if="mode !=='pay'"
        v-bind:class="{
          'app-side-sidebar-shown': !sidebarShown,
          'app-side-cupping': mode == 'live2',          
          'no-left-margin': (mode == 'login') ||
                            (mode == 'privacy') ||
                            (mode == 'terms') ||
                            (mode == 'contact'),
        }">
          <DashHeader :mode ="mode" v-if="mode == 'live2'" />
          <Landing v-if="mode == 'landing'" />
          <Product v-if="mode == 'product'" :feel="feelProduct" />
          <Account v-if="mode == 'account'" />
          <Login v-if="mode == 'login'" />
          <GetPro v-if="mode == 'getpro'" />
          <Faq v-if="mode == 'faq'" />
          <Previous v-if="mode == 'previous'" />
          <Live v-if="mode == 'live'" />
          <Live2 v-if="mode == 'live2'" />
          <Live2 v-if="mode == 'cupping'" :mode="'cupping'" />
          <Live3 v-if="mode == 'live3'" />
          <Coffees v-if="mode == 'coffees'" />
          <Host v-if="mode == 'host'" />
          <AddProduct v-if="mode == 'add-product'" />
          <AddTemplate v-if="mode == 'add-template'" />
          <Dashboard v-if="mode == 'dashboard'" />
          <Settings v-if="mode == 'settings'" />
          <Products v-if="mode == 'products'" />
          <Sessions v-if="mode == 'sessions'" />
          <Templates v-if="mode == 'templates'" />
          <Template v-if="mode == 'template'" />
          <Contact v-if="mode == 'contact'" />
          <Privacy v-if="mode == 'privacy'" />
          <Terms v-if="mode == 'terms'" />
          
          <Footer v-if="hideFooter.indexOf(mode) < 0" :mode="mode" />
        </div>

      </div>

  </div>
</template>

<script>

import Landing from './Landing'
import Product from './Product'
import Account from './Account'
import Login from './Login'
import GetPro from './GetPro'
import Faq from './Faq'
import Previous from './Previous'
import Live from './Live'
import Live2 from './Live2'
import Live3 from './Live3'
import Coffees from './Coffees'
import Host from './Host'
import Header from './Header'
import DashHeader from './DashHeader'
import LandingHeader from './LandingHeader'
import Footer from './Footer'
import Sidebar from './Sidebar'
import Dashboard from './Dashboard'
import Settings from './Settings'
import Products from './Products'
import Sessions from './Sessions'
import Templates from './Templates'
import Template from './Template'
import AddProduct from './AddProduct'
import AddTemplate from './AddTemplate'
import Contact from './Contact'
import Privacy from './Privacy'
import Terms from './Terms'

export default {
  name: 'AppWrap',
  data () {
    return {
      sidebarShown: false,
      feelProduct: '',
      showHeader1: [
        'login',
        'contact',
        'privacy',
        // 'settings',
        'terms',
      ],
      showSidebar: [
        // 'landing',
        'cupping',
        'settings',
        'products',
        'coffees',
        'sessions',
        'dashboard',
        'templates',
        'template',
        'add-product',
        'add-template',
      ],
      hideFooter: [
        'account'
      ],
      lastWidth: 0
    }
  },
  props: ['mode'],
  components: {
    Landing,
    Product,
    Account,
    Login,
    GetPro,
    Faq,
    Previous,
    Live,
    Live2,
    Live3,
    Coffees,
    Host,
    Sidebar,
    Dashboard,
    Settings,
    Products,
    Sessions,
    Templates,
    Template,
    AddProduct,
    AddTemplate,
    Header,
    DashHeader,
    LandingHeader,
    Footer,
    Contact,
    Privacy,
    Terms,
  },
  methods: {
    setSidebarShown (v, m) {
      console.log('setSidebarShown', v, m)
      this.sidebarShown = v
    },
    loadProduct () {
      let hash = this.$route.hash
      hash = hash.substring(1, hash.length)
      this.feelProduct = hash
    },
    checkIfSidebarShouldBeCollapsed () {
      let width = window.innerWidth
      let diff = this.lastWidth - width
      if (diff > 0) { // sizing down
        if ((width < 980) && (this.lastWidth >= 980)) {
          this.sidebarShown = false
        }
      } else {
        if ((this.lastWidth < 980) && (width >= 980)) {
          this.sidebarShown = true
        }
      }
      this.lastWidth = width
    }
  },
  computed: {

  },
  watch: {
    $route (to, from) {
      if (to !== from) {
        this.loadProduct()
      }
    }
  },
  mounted () {
  },
  created () {
    window.onresize = this.checkIfSidebarShouldBeCollapsed
    let width = window.innerWidth
    this.lastWidth = width
    if (width > 980) {
      this.sidebarShown = true
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../styles/settings.scss";
  $sidebar-width: 250px;
  .app-wrap {
    min-height: 100vh;
    /*max-width: $max-width;*/
    width: 100%;
  }
  .app-bottom {
    width: 100%;
    margin-top: 94px;
  }
  .header {
    position: absolute;
    top: 0;
    // z-index: 1000000;
  }
  .sidebar {
    position: absolute;
    top: calc(79px + 17px) !important;
    // height: calc(100% - 114px) !important;
    // max-height: calc(100vh - 114px) !important;
    min-height: 500px !important;
    // min-height: calc(100vh - 113px);
    margin-left: 15px;
    border: 5px;
    border-radius: 5px;
    
    // position: sticky;
    align-self: flex-start;
    height: calc(100% - 114px) !important;
    max-height: calc(100vh - 114px) !important;
    top: 94px !important;
    // margin-bottom: 15px;

  }
  @media (max-height: 550px) {
    .sidebar {
      height: 100% !important;
      max-height: unset !important;
    }
  }
  .app-side {
    overflow: hidden;
    min-height: 100vh;
    max-width: 100%;
    margin-left: calc(#{$sidebar-width} + 15px);
    transition: all 0.5s ease;
    // padding-top: calc(79px + 17px) !important;
  }
  .app-side-cupping {
    margin-left: 0;
  }
  .app-bottom-cupping {
    margin-top: 0;
  }
  .show-sidebar {
    .app-side {
      max-width: calc(100% - 280px);
    }
  }
  .sidebar-bg {
    position: fixed;
    z-index: 100;
    background-color: #00000033;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
  }
  @media (min-width: 980px) {
    .sidebar-bg {
      display: none;
    }
  }
  @media (max-width: 980px) {
    .sidebar {
      margin-left: 0;
      height: 100vh !important;
      max-height: 100vh !important;
      top: 0 !important;
      border-radius: 0;
    }
    .app-side {
      max-width: 100%;
      margin-left: 0;
    }
  }
  .app-side-sidebar-shown {
    margin-left: 0;
  }
  .no-top-margin {
    margin-top: 0;
  }
  .no-left-margin {
    margin-left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/AppWrap.vue